import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { lookupInvite, acceptInvite } from '../actions/inviteActions';

export default function AcceptInvite() {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError]   = useState('');
  const [form, setForm]     = useState({ name: '', username: '', password: '' });
  const [busy, setBusy]     = useState(false);

  useEffect(() => {
    (async () => {
      const res = await dispatch(lookupInvite(token));
      if (res.ok) {
        setInvite(res.invite);
        setForm(f => ({ ...f, name: res.invite.name || '' }));
      } else setError(res.error);
    })();
  }, [dispatch, token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await dispatch(acceptInvite(token, form));
    setBusy(false);
    if (res.ok) navigate('/dashboard');
    else setError(res.error);
  };

  if (error) return <section className="section narrow"><h1>Invite</h1><p className="status error">{error}</p></section>;
  if (!invite) return <section className="section narrow"><h1>Invite</h1><p>Loading…</p></section>;

  if (invite.status !== 'pending') {
    return <section className="section narrow"><h1>Invite is {invite.status}</h1>
      <p className="muted">This invite is no longer active. Ask whoever sent it to send a new one.</p></section>;
  }

  return (
    <section className="section narrow">
      <h1>Accept your invite</h1>
      <p className="muted">
        Invited as <strong>{invite.roleSlug}</strong>{invite.invitedBy?.email ? <> by <strong>{invite.invitedBy.email}</strong></> : null}.
      </p>
      <form className="auth-form" onSubmit={submit}>
        <label>Email<input type="email" value={invite.email} readOnly /></label>
        <label>Name<input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></label>
        <label>Username (optional)<input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} /></label>
        <label>Choose a password<input required type="password" minLength={8} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} /></label>
        <button className="btn-primary" type="submit" disabled={busy}>{busy ? 'Joining…' : 'Accept invite'}</button>
      </form>
    </section>
  );
}
